import { Badge, Tabs } from 'antd'
import React from 'react'
import { t } from 'i18next'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import dayjs from 'dayjs'
import AppointmentCards from './AppointmentCards'
import AppointmentList from './AppointmentList'
import Title from 'antd/es/typography/Title'
import { Color } from '../../Common/Color'

export default function AppointmentsTab ({ appointments }) {
  const patientAppointments = appointments.filter(appointment => appointment.type === 'PatientAppointment')
  const cleaningAppointments = appointments.filter(appointment => appointment.type === 'CleaningAppointment')
  const maintenanceAppointments = appointments.filter(appointment => appointment.type === 'MaintenanceAppointment')
  const workAppointments = appointments.filter(appointment => appointment.type === 'WorkAppointment')
  const screens = useBreakpoint()

  const ongoingAppointment = (appointment) => (
    ['clean_in_progress', 'late', 'in_progress', 'person_left'].includes(appointment.state)
  )

  const nearAppointment = (appointment) => (
    appointment.state === 'waiting' && dayjs(appointment.begin_date) <= dayjs().add(1, 'hour')
  )

  const nextAppointment = (appointment) => (
    appointment.state === 'waiting' && dayjs(appointment.begin_date) > dayjs().add(1, 'hour')
  )

  const doneAppointment = (appointment) => (
    appointment.state === 'done'
  )

  const canceledAppointment = (appointment) => (
    appointment.state === 'auto_cancel' || appointment.state === 'cancel'
  )

  const currentAppointmentTab = (appointments) => {
    return displayedAppointments(appointments.filter((appointment) => ongoingAppointment(appointment) || nearAppointment(appointment)))
  }

  const nextAppointmentsTab = (appointments) => {
    return displayedAppointments(appointments.filter((appointment) => nextAppointment(appointment)))
  }

  const doneAppointmentsTab = (appointments) => {
    return displayedAppointments(appointments.filter((appointment) => doneAppointment(appointment)))
  }

  const canceledAppointmentsTab = (appointments) => {
    return displayedAppointments(appointments.filter((appointment) => canceledAppointment(appointment)))
  }

  const allAppointments = (appointments) => {
    return displayedAppointments(appointments)
  }

  const displayedAppointments = (appointments) => {
    return (
      <>
        <Title level={4} style={{ marginTop: '0' }} >{`${appointments.length} RDV`}</Title>
        { screens.xs && <AppointmentCards appointments={appointments} /> }
        { !screens.xs && <AppointmentList filteredAppointments={appointments} /> }
      </>
    )
  }

  const subTab = (appointments) => (
    <Tabs
      tabPlacement='left'
      defaultActiveKey='current'
      style={screens.xs ? { '--ant-tabs-vertical-item-padding': '8px 10px' } : {}}
      items={[
        {
          label: t('Admin.AppointmentsPage.tab.currentAppointments'),
          key: 'current',
          children: currentAppointmentTab(appointments)
        },
        {
          label: t('Admin.AppointmentsPage.tab.nextAppointments'),
          key: 'next',
          children: nextAppointmentsTab(appointments)
        },
        {
          label: <Badge count={appointments.filter(ap => ap.state === 'done' && !ap.feedback_done).length}
            style={{ '--ant-badge-indicator-height': '13px', fontSize: '11px', lineHeight: '12px' }}>
              {t('Admin.AppointmentsPage.tab.doneAppointments')}
            </Badge>,
          key: 'done',
          children: doneAppointmentsTab(appointments)
        },
        {
          label: t('Admin.AppointmentsPage.tab.canceledAppointments'),
          key: 'canceled',
          children: canceledAppointmentsTab(appointments)
        },
        {
          label: t('Admin.AppointmentsPage.tab.allAppointments'),
          key: 'allAppointments',
          children: allAppointments(appointments)
        }
      ]}
    />
  )

  return (
    <Tabs
      type='card'
      classNames={{ item: 'custom-tab-header' }}
      style={{ '--backgroundColor': Color.primary }}
      styles={{ root: { marginTop: '1em', backgroundColor: 'white' }, content: { padding: '0em 1em 1em 0em' } }}
      defaultActiveKey='all'
      items={[
        {
          label: t('Admin.AppointmentsPage.tab.allAppointments'),
          key: 'all',
          children: subTab(appointments)
        },
        {
          label: t('Admin.AppointmentsPage.tab.patientAppointments'),
          key: 'patient',
          children: subTab(patientAppointments)
        },
        {
          label: t('Admin.AppointmentsPage.tab.cleaningAppointments'),
          key: 'cleaning',
          children: subTab(cleaningAppointments)
        },
        {
          label: t('Admin.AppointmentsPage.tab.maintenanceAppointments'),
          key: 'maintenance',
          children: subTab(maintenanceAppointments)
        },
        {
          label: t('Admin.AppointmentsPage.tab.workAppointments'),
          key: 'work',
          children: subTab(workAppointments)
        }
      ]}
    />
  )
}
